import React from "react";
import { Box, Typography } from "@mui/material";

/**
 * Generic section wrapper with title and optional count.
 * Props:
 * - title: string (e.g., "Checking Accounts")
 * - count: number | null
 * - children: nodes (list of items/cards)
 */
export default function ListSection(props) {
  const { title, count = null, children } = props;
  return (
    <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
      <Box sx={{ display: "flex", alignItems: "baseline", gap: 1 }}>
        <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
        {typeof count === "number" ? (
          <Typography variant="body2" color="text.secondary">
            ({count})
          </Typography>
        ) : null}
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {children}
      </Box>
    </Box>
  );
}
